import "./Button.css";

export const Button = ({action, icon, text, color}) => {
    return (
        <button className='iconButton' onClick={action} style={{backgroundColor: color}}>
            {icon && <img className='icon' src={icon} alt=''/>}
            <span>{text}</span>
        </button>
    )
}